import { RootAppState } from 'store/configureStore'
import { bomItemSelector } from './bomItemSelector'

export const bomItemNestingTypeSelector =
  (bomItemId: string) => (state: RootAppState) => {
    const bomItem = bomItemSelector(state, bomItemId)

    switch (bomItem?.type) {
      case 'Row':
        return {
          selectedDirection: bomItem.selectedNestingDirection,
          selectableDirections: bomItem.selectableNestingDirections,
        }
      default:
        return null
    }
  }
